export default {
    type: {
        "ac_router": "Elérte a váltóáramú routerek rendelési korlátját",
        "chair": "Elérte a székek rendelési korlátját",
        "default": "Elérted a rendelési limitet",
        "default_multiple": "Elérte a hasonló termékek rendelési korlátját",
        "desk": "Elérte az asztalok rendelési korlátját",
        "desktop": "Elérted az asztali számítógépre vonatkozó rendelési limitet",
        "desktop_riser": "Elérte az asztali állványok rendelési korlátját",
        "detector": "Elérted a vape- és zajérzékelők rendelési korlátját",
        "displayport_cable": "Elérte a DisplayPort kábelek rendelési korlátját",
        "docking station": "Elérte a dokkolóállomások rendelési korlátját",
        "dual_usb_adapter": "Elérte a kétsávos USB adapterek rendelési korlátját",
        "ear cushion": "Elérte a fülpárnák rendelési korlátját",
        "footrest": "Elérte a lábtartók rendelési korlátját",
        "hdmi_cable": "Elérte a HDMI-kábelek rendelési korlátját",
        "hdmi_displayport_cable": "Elérte a HDMI-DisplayPort kábelek rendelési korlátját",
        "hdmi_vga_cable": "Elérted a HDMI-VGA kábelek rendelési korlátját",
        "headset": "Elérte az audioeszközök rendelési korlátját",
        "keyboard": "Elérted a billentyűzetek rendelési korlátját",
        "kvm switch": "Elérte a KVM switchek rendelési korlátját",
        "kvm_switch": "Elérte a KVM switchek rendelési korlátját",
        "lamp": "Elérte a lámpák rendelési korlátját",
        "laptop stand": "Elérte a laptopállványok rendelési korlátját",
        "laptop": "Elérte a laptopok rendelési korlátját",
        "mesh_router": "Elérted a mesh routerek rendelési korlátját",
        "monitor": "Elérte a monitorok rendelési korlátját",
        "mouse": "Elérted az egerek rendelési korlátját",
        "patch_cord": "Elérte a Cat6 patch kábelek rendelési korlátját",
        "power": "Elérte a tápkábelek rendelési korlátját",
        "power_center": "Elérte az Energiaközpontok rendelési korlátját",
        "power_strip": "Elérte az elosztók rendelési korlátját",
        "printer": "Elérte a nyomtatók rendelési korlátját",
        "smart_plug": "Elérte a mini okoscsatlakozók rendelési korlátját",
        "smart_power_strip": "Elérte az okos elosztók rendelési korlátját",
        "speakerphone": "Elérte a kihangosítók rendelési korlátját",
        "stylus": "Elérte a stylusok rendelési korlátját",
        "tablet": "Elérte a tabletek rendelési korlátját",
        "tablet accessory": "Elérte a táblagép-kiegészítők rendelési korlátját",
        "thunderbolt_cable": "Elérted az USB-C - Thunderbolt rendelési korlátját",
        "travel_router": "Elérte az utazó routerek rendelési korlátját",
        "usb hub": "Elérte az USB-elosztók rendelési korlátját",
        "usb_adapter": "Elérte az USB adapterek rendelési korlátját",
        "usb_hub": "Elérte az USB-elosztók rendelési korlátját",
        "webcam": "Elérted a webkamerák rendelési korlátját"
    }
}